/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const _color = [{id: 1, forecolor:'#3788d8'},{id: 2, forecolor:'#0E6251'},{id: 3, forecolor:'#9A7D0A'},{id: 4, forecolor:'#8E44AD'},{id: 5, forecolor:'#E67E22'} ]
const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

const Home = (props) => {
  
  var moment = require('moment');
  require('moment/locale/th');

  useEffect(() => {

  },[]);

    const classes = useStyles();
    const classes2 = useStyles2();

    return (

        <div>
          <Grid>
            {[
                    {icon: "fas fa-file-signature", title: "ลงนามคำรับรอง ฯ ปีงบประมาณ 2567", color: "#4529ff", url: "/signature"},
                    {icon: "fas fa-signature", title: "ลงนามคำรับรอง ฯ ปีงบประมาณ 2568", color: "#b85f5f", url: "/signature2568"},
                    {icon: "fas fa-signature", title: "ลงนามคำรับรอง ฯ ปีงบประมาณ 2569", color: "#b85f5f", url: "/signature2569"}

              ].map((card, key) => {
              if(card.isVisible==undefined || card.isVisible)
                return (

                      <Col xs={12} sm={4} md={4} lg={3} xl={2}>
                        <a href={card.url}>
                            <Card style={{height:'110px'}}>
                          <CardHeader stats icon>
                            <CardIcon color={card.color} style={{float: 'left', padding: '15px', marginTop: '-20px', marginRight: '15px', borderRadius: '6px', backgroundColor: card.color}}>
                                <i className={card.icon+" fa-2x" }></i>
                            </CardIcon>
                            <p className={classes2.cardCategory}></p>
                            <h4 className={classes2.cardTitle}>
                              {card.title}
                            </h4>
                          </CardHeader>
                          <CardBody>        
                          </CardBody>
                        </Card>
                        </a>

                      </Col>
                );
             else 
                return (<></>);      
            })}     
          </Grid>
        </div>
    );
}



export default Home;